var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PanamaLayout',{attrs:{"roles":_vm.roles}},[(_vm.profile && _vm.profile.subject)?_c('div',[_c('UserProfile',{attrs:{"profile":_vm.profile}}),_c('hr'),_c('EmailVerified',{attrs:{"profile":_vm.profile}}),_c('hr'),_c('SecretQuestion',{attrs:{"profile":_vm.profile}}),_c('hr'),_c('DigitalPin',{attrs:{"profile":_vm.profile}}),_c('hr'),(
        _vm.profile &&
        _vm.profile.passport &&
        (_vm.profile.passportPhoto === '' ||
          _vm.profile.passportPhoto === null ||
          _vm.profile.profilePhoto === '' ||
          _vm.profile.profilePhoto === null)
      )?_c('RecognitionPassport',{attrs:{"profile":_vm.profile}}):_vm._e(),(_vm.profile && _vm.profile.passport)?_c('hr'):_vm._e(),_c('AdditionalProfile',{attrs:{"profile":_vm.profile}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }